import { useMemo } from 'react';

import { useConfig } from '../../defaultConfig';
import { useAccounts } from '../../fetchHooks/useAccount';
import { noStoppedCrossBorderPayments, useStoppedPaymentItems } from '../../fetchHooks/usePaymentItems';
import useTranslation from '../../hooks/useTranslation';
import formatPaymentItems from './formatPaymentItems';

export default () => {
    const { featureToggles } = useConfig();
    const translations = useTranslation();
    const {
        data: stoppedPayments = [],
        isLoading: isLoadingPayments,
        isSuccess,
        error,
        refetch: paymentItemRefetch,
    } = useStoppedPaymentItems(featureToggles.enableRejectedPaymentItems, {
        select: !featureToggles.enableStoppedCrossBorderPayments ? noStoppedCrossBorderPayments : undefined,
    });

    const {
        data: accounts,
        isLoading: isLoadingAccounts,
        refetch: accountRefetch,
    } = useAccounts({
        enabled: featureToggles.enableRejectedPaymentItems,
    });

    const refetch = () => {
        paymentItemRefetch();
        accountRefetch();
    };

    const isLoading = isLoadingPayments || isLoadingAccounts;

    const formattedStoppedPayments = useMemo(
        () => formatPaymentItems(translations)(stoppedPayments, accounts),
        [stoppedPayments, accounts, translations],
    );

    return {
        isLoading,
        formattedStoppedPayments,
        isSuccess,
        error,
        refetch,
        enabled: featureToggles.enableRejectedPayments,
    };
};
